import { Button, Typography } from "@mui/material"
import { Page } from "../styled"
import { Column, Header, ProjectItem, ProjectsContainer } from "./styled"
import { useMainStore } from "store"
import { observer } from "mobx-react-lite"
import SchemesList from "./schemes"
import ContentList from "./contents"
import { num } from "utils/lang"
import { useDialogStore } from "dialogs"
import { ContextMenu, useContextMenu } from "components/context-menu"
import Project from "store/project"
import { useRef } from "react"

import AddIcon from "components/icons/editor/add"
import ImportIcon from "components/icons/other/import"
import ExportIcon from "components/icons/other/export"
import DeleteIcon from "components/icons/editor/delete"
import CopyIcon from "components/icons/editor/copy"

const ProjectsPage = observer(() => {

  const inputRef = useRef<HTMLInputElement>(null)
  const dialog = useDialogStore()
  const store = useMainStore()

  const onDeleteProject = (project: Project) => {
    dialog.open("delete", { content: `Проект «${project.name}» будет удален`, onConfirm: () => {
      store.deleteProject(project.id)
    }})
  }

  const exportProject = (project: Project) => {
    dialog.open("exportProject", { project })
  }

  const importProject = (project: Project | unknown) => {
    if (!inputRef.current) return
    inputRef.current.click()
    inputRef.current.onchange = (e) => {
      const target = e.target as HTMLInputElement
      const file = target?.files && target?.files[0]
      if (!file) return

      file.text().then(text => {
        const data = JSON.parse(text)
        dialog.open("importProject", { data, project })
      })
      
      target.value = ""
    }
  }

  const dublicateProject = (project: Project) => {
    dialog.open("newSite", { copyProject: project })
  }

  const contextMenu = useContextMenu(() => ([
    { title: "Экспорт данных", icon: <ExportIcon/>, onClick: exportProject },
    { title: "Импорт данных", icon: <ImportIcon/>, onClick: importProject },
    { title: "Дублировать проект", icon: <CopyIcon/>, onClick: dublicateProject },
    { title: "Удалить проект", icon: <DeleteIcon/>, onClick: onDeleteProject, sx: { color: "primary.dark" } }
  ]))

  const contextMenuImport = useContextMenu(() => ([
    { title: "Импорт проекта", icon: <ImportIcon/>, onClick: importProject },
  ]))

  const clickOnColumn = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget || (e.target as HTMLDivElement).parentElement === e.currentTarget) {
      store.selectProject(null)
    }
  }

  return (
    <Page sx={{ display: "flex", justifyContent: "center" }}>
      <Column 
        onClick={clickOnColumn} 
        onContextMenu={contextMenuImport.open}
        sx={{ my: 5, mr: 2, ml: "auto", maxWidth: 500 }}
      >
        <Header>
          <Typography fontSize={32} fontWeight={700}>Сайты</Typography>
          <Button variant="contained" color="secondary" sx={{ ml: "auto" }} onClick={() => dialog.open("newSite")}>
            <AddIcon sx={{ mr: 1, fontSize: 16 }}/>
            Добавить сайт
          </Button>
        </Header>
        <ProjectsContainer sx={{ mt: 3 }}>
          { Array.from(store.projects.values()).map(item => (
            <ProjectItem 
              key={item.id} 
              selected={store.selectedProject === item.id} 
              onClick={() => store.selectProject(item.id)}
              onContextMenu={(e) => contextMenu.open(e, item)}
            >
              <Typography fontSize="1em" fontWeight={700}>{item.name}</Typography>
              <Typography color="text.secondary">
                { num(item.contents.size, "блок", "блока", "блоков") }
              </Typography>
            </ProjectItem>
          ))}
        </ProjectsContainer>
      </Column>
      { !store.selectedProject? (
        <SchemesList onImportClick={importProject}/>
      ): (
        <ContentList/>
      )} 
      <ContextMenu store={contextMenu}/>
      <ContextMenu store={contextMenuImport}/>
      <input ref={inputRef} type="file" accept="application/json" style={{ display: "none" }}/>
    </Page>
  )
})

export default ProjectsPage